import { useQuery } from "hooks/useQuery";
import { EMPTY_FOLDER_MESSAGE } from "../../constants/documents";
import EmptyFolder from "../../static/images/EmptyFolder.svg";

export const NoDocumentItem = ({
  hideUploadText,
}: {
  hideUploadText?: boolean;
}) => {
  const query = useQuery();
  const searchTerm = query.get("search");

  return (
    <div className="t-flex t-justify-center t-items-center t-flex-col t-gap-12 t-h-[70dvh]">
      <img src={EmptyFolder} alt="empty folder" />
      <div className="t-flex t-justify-center t-items-center t-flex-col">
        <h4 className="t-text-subtext t-text-text-black">
          {EMPTY_FOLDER_MESSAGE}
        </h4>
        {!searchTerm && !hideUploadText && (
          <p className="t-text-subtitle t-text-text-30">
            Drop files here or use 'New' button
          </p>
        )}
      </div>
    </div>
  );
};
